exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/quiz-compound-assessment.js-WebpackMultiOutput";